// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2WWUw","right":"styles_right__1LpRX"};